import {Component, inject, Input, input, OnInit} from '@angular/core';
import {ButtonComponent} from "../../../shared/components/button/button.component";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TextInputComponent} from "../../../shared/inputs/text-input/text-input.component";
import {BaseComponent} from "../../../shared/base/base-component";
import {
  type AdminForgotPasswordRequest,
  type AdminForgotPasswordResponse, AdminResetPasswordRequest, AdminResetPasswordResponse,
  type AdminSetupPasswordResponse,
  SetupPasswordRequest
} from "../../../core/api/model";
import {ApiService} from "../../../core/api/api.service";
import {State} from "../../../shared/base/base-state";

@Component({
  selector: 'app-reset-password',
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    TextInputComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  @Input() token?: string;
  formBuilder = inject(FormBuilder);
  resetPasswordForm!: FormGroup;

  resetPasswordState = new State<AdminResetPasswordResponse>();
  apiService = inject(ApiService);

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.resetPasswordForm = this.formBuilder.group({
      password: ["", Validators.required],
      confirmPassword: ["", Validators.required],
    }, {validators: [this.passwordsMatchValidator]});
  }

  passwordsMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : {passwordsMismatch: true};
  }

  onResetPasswordClicked() {
    if (!this.resetPasswordForm.valid) {
      return;
    }
    let formData = this.resetPasswordForm.value;
    let request: AdminResetPasswordRequest = {
      token: this.token ?? '',
      password: formData.password,
    }
    this.executeRequest<AdminResetPasswordResponse>({
      state: this.resetPasswordState,
      request: this.apiService.resetAdminPassword(request),
      handleSuccess: true,
      onSuccess: () => {
        this.tokenService.logout();
        this.router.navigate(['/login']);
      }
    });
  }

  onLoginClicked() {
    this.router.navigate(['/login']);
  }
}
